/* eslint-disable no-plusplus */
/* eslint-disable new-cap */
/* eslint-disable react/prop-types */
import React, { useContext } from "react";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Box from "@mui/material/Box";
import { useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";
// import moment from "moment";
import styles from "./ExportButton.styles";
import Button from "../../../../components/common/Button/index";
// import Reports from "../../../../services/api/reports";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import { AlertStatus } from "../../../../contants";
// import Examination from "../../../../services/api/examination";

function ExportButton({ data, exportFunction }) {
  const toast = useContext(ToastAlertContext);
  // const [id, setId] = useState(null);
  // const [fullName, setFullName] = useState(null);
  const location = useLocation();
  // useEffect(() => {
  //   const queryParams = new URLSearchParams(location.search);
  //   const Id = queryParams.get("id");
  //   setId(Id);
  //   const FullName = queryParams.get("fullName");
  //   setFullName(FullName);
  // }, [location.search]);
  const handleExport = async () => {
    const queryParams = new URLSearchParams(location.search);
    try {
      // eslint-disable-next-line no-unused-vars
      // OLD (bug): selectedDate was not sent in download payload, so backend couldn't filter like UI search.
      // const payload = {
      //   examLevel: queryParams?.get("examLevel") || null,
      //   fullName: queryParams?.get("fullName") || null,
      //   mobileNumber: queryParams?.get("mobileNumber") || null,
      //   divisionId: queryParams?.get("divisionId") || null,
      //   areaId: queryParams?.get("areaId") || null,
      //   clusterId: queryParams?.get("clusterId") || null,
      //   zoneId: queryParams?.get("zoneId") || null,
      //   regionId: queryParams?.get("regionId") || null,
      //   chapterId: queryParams?.get("chapterId") || null,
      //   districtId: queryParams?.get("districtId") || null,
      //   blockId: queryParams?.get("blockId") || null,
      //   memberId: queryParams?.get("memberId") || null,
      // };

      const payload = {
        examLevel: queryParams?.get("examLevel") || null,
        fullName: queryParams?.get("fullName") || null,
        mobileNumber: queryParams?.get("mobileNumber") || null,
        divisionId: queryParams?.get("divisionId") || null,
        areaId: queryParams?.get("areaId") || null,
        clusterId: queryParams?.get("clusterId") || null,
        zoneId: queryParams?.get("zoneId") || null,
        regionId: queryParams?.get("regionId") || null,
        chapterId: queryParams?.get("chapterId") || null,
        districtId: queryParams?.get("districtId") || null,
        blockId: queryParams?.get("blockId") || null,
        memberId: queryParams?.get("memberId") || null,
        selectedDate: queryParams?.get("selectedDate") || null,
      };
      const response = await exportFunction({
        data: payload,
      });
      const { name } = response.data;
      if (response.code === 200) {
        toast.show(
          `${name} will be available shortly under downloads`,
          AlertStatus.SUCCESS
        );
      }
    } catch (error) {
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
      Sentry.captureException(error);
    }
  };

  const disabled = !data || !data.length;

  return (
    <Box style={{ ...styles.dropdown, ...(disabled ? styles.disabled : {}) }}>
      <Box style={styles.dropdownBtn}>
        {" "}
        <Button
          variant="outlined"
          style={styles.leftSideBtn}
          onClick={handleExport}
          label="Download Reports"
          startIcon={
            <SaveAltIcon
              sx={{
                fontSize: "18px",
                fontWeight: "100",
              }}
            />
          }
        />
        <Box sx={styles.arrowIcon}>
          <ArrowDropDownIcon />
        </Box>
      </Box>
    </Box>
  );
}

export default ExportButton;
